const HEADING = {
  ADDITIONAL_INFO: 'Informações adicionais',
  PRODUCT_SUGGESTION: 'Ofertas relacionadas',
  PAID_MEDIA: 'Publicidade',
  STORE_INFO: 'Informações sobre a loja',
  COMMENT: 'Comentários',
  SEE_ALSO: 'Veja também',
  SOCIAL_MEDIA: 'Siga-nos nas Redes',
};

export default HEADING;
